export default __webpack_public_path__ + "static/media/other_cards_02.5080557e.png";